//#region src/protocol/methods.ts
/**
* Method name constants and MethodName type.
*/
const Methods = {
	Initialize: "initialize",
	Shutdown: "shutdown",
	SessionCreate: "session/create",
	SessionClose: "session/close",
	SessionSync: "session/sync",
	SessionGetState: "session/getState",
	SessionGetOutput: "session/getOutput",
	SessionExplain: "session/explain",
	SessionList: "session/list",
	SessionWatch: "session/watch",
	SessionUnwatch: "session/unwatch",
	ExecutionStart: "execution/start",
	ExecutionGetState: "execution/getState",
	ExecutionCancel: "execution/cancel",
	JobList: "job/list",
	JobGetState: "job/getState",
	JobCancel: "job/cancel",
	SidecarList: "sidecar/list",
	SidecarShutdown: "sidecar/shutdown",
	SidecarSpawn: "sidecar/spawn",
	SidecarCall: "sidecar/call",
	SidecarCallStart: "sidecar/callStart",
	PluginList: "plugin/list",
	PluginGetManifest: "plugin/getManifest",
	PluginApiCall: "plugin/apiCall",
	ExtensionList: "extension/list",
	ExtensionGetManifest: "extension/getManifest",
	ExtensionActivateRuntime: "extension/activateRuntime",
	ExtensionInvoke: "extension/invoke",
	ExtensionDisposeRuntime: "extension/disposeRuntime",
	ExtensionSettingsUpdate: "extension/settings.update",
	SmartIntakePropose: "smart-intake/propose",
	SmartIntakeBuildPlan: "smart-intake/buildPlan",
	ConfigGet: "config/get",
	ConfigSet: "config/set",
	ConfigGetSchema: "config/getSchema",
	ConfigReload: "config/reload",
	EventExecutionStarted: "event/execution.started",
	EventExecutionProgress: "event/execution.progress",
	EventExecutionCompleted: "event/execution.completed",
	EventExecutionFailed: "event/execution.failed",
	EventExecutionCascade: "event/execution.cascade",
	EventExecutionIterationStarted: "event/execution.iterationStarted",
	EventExecutionIterationCompleted: "event/execution.iterationCompleted",
	EventExecutionJobChanged: "event/execution.jobChanged",
	EventTraceStarted: "event/trace.started",
	EventTraceProgress: "event/trace.progress",
	EventTraceCompleted: "event/trace.completed",
	EventJobChanged: "event/job.changed",
	EventDocumentChanged: "event/document.changed",
	EventDocumentSaved: "event/document.saved",
	EventDocumentActivity: "event/document.activity",
	EventSessionCreated: "event/session.created",
	EventSessionClosed: "event/session.closed",
	EventEngineReady: "event/engine.ready",
	EventSidecarSpawned: "event/sidecar.spawned",
	EventSidecarStopped: "event/sidecar.stopped",
	EventSidecarRestarted: "event/sidecar.restarted",
	EventFileChanged: "event/file.changed",
	EventLog: "event/log",
	EventConfigChanged: "event/config.changed",
	PushScan: "push/scan",
	PushConnect: "push/connect",
	PushDisconnect: "push/disconnect",
	PushPair: "push/pair",
	PushSend: "push/send",
	PushSyncStart: "push/syncStart",
	PushSyncStop: "push/syncStop",
	PushStatus: "push/status",
	EventPushDeviceFound: "event/push.deviceFound",
	EventPushDeviceLost: "event/push.deviceLost",
	EventPushConnectionChanged: "event/push.connectionChanged",
	EventPushPairingChallenge: "event/push.pairingChallenge",
	EventPushPairingResult: "event/push.pairingResult",
	EventPushAck: "event/push.ack",
	EventPushSyncStatus: "event/push.syncStatus",
	McpStart: "mcp/start",
	McpStop: "mcp/stop",
	McpStatus: "mcp/status",
	McpLogs: "mcp/logs",
	EventMcpStatusChanged: "event/mcp.statusChanged",
	EventMcpRequestLog: "event/mcp.requestLog",
	EventExtensionDomain: "event/extension",
	EventStreamChunk: "event/stream.chunk",
	EventStreamState: "event/stream.state",
	EventStreamDropSummary: "event/stream.dropSummary",
	WorkspaceReadDir: "workspace/readDir",
	WorkspaceReadFile: "workspace/readFile",
	WorkspaceWriteFile: "workspace/writeFile",
	WorkspaceStat: "workspace/stat",
	WorkspaceExists: "workspace/exists",
	WorkspaceMkdir: "workspace/mkdir",
	WorkspaceRename: "workspace/rename",
	WorkspaceRemove: "workspace/remove",
	WorkspaceCopy: "workspace/copy",
	WorkspaceMove: "workspace/move",
	WorkspaceReferenceImpact: "workspace/referenceImpact",
	SearchQuery: "search/query",
	SearchCancel: "search/cancel",
	EventSearchResults: "event/search.results",
	EventSearchComplete: "event/search.complete",
	EventSearchError: "event/search.error",
	WorkspaceGetInfo: "workspace/getInfo",
	WorkspaceAddFolder: "workspace/addFolder",
	WorkspaceRemoveFolder: "workspace/removeFolder",
	WorkspaceListFolders: "workspace/listFolders",
	WorkspaceSave: "workspace/save",
	WorkspaceLoad: "workspace/load",
	WorkspaceStarList: "workspace/star.list",
	WorkspaceStarAdd: "workspace/star.add",
	WorkspaceStarRemove: "workspace/star.remove",
	WorkspaceStarUpdate: "workspace/star.update",
	WorkspaceSessionGet: "workspace/session.get",
	WorkspaceSessionSet: "workspace/session.set",
	WorkspaceBookmarkList: "workspace/bookmark.list",
	WorkspaceBookmarkAdd: "workspace/bookmark.add",
	WorkspaceBookmarkRemove: "workspace/bookmark.remove",
	WorkspaceBookmarkUpdate: "workspace/bookmark.update",
	EventWorkspaceFileChanged: "event/workspace.fileChanged",
	EventWorkspaceFoldersChanged: "event/workspace.foldersChanged",
	EventWorkspaceStarsChanged: "event/workspace.starsChanged",
	EventWorkspaceBookmarksChanged: "event/workspace.bookmarksChanged",
	EventGatewayEngineStatus: "event/gateway.engineStatus",
	IntelligenceComplete: "intelligence/complete",
	IntelligenceHover: "intelligence/hover",
	IntelligenceDiagnostics: "intelligence/diagnostics",
	IntelligenceDefinition: "intelligence/definition",
	IntelligenceReferences: "intelligence/references",
	IntelligenceRename: "intelligence/rename",
	IntelligenceSymbols: "intelligence/symbols",
	IntelligenceSemanticTokens: "intelligence/semanticTokens",
	IntelligenceCodeAction: "intelligence/codeAction",
	IntelligenceInlayHint: "intelligence/inlayHint",
	EventIntelligenceDiagnosticsPublished: "event/intelligence.diagnosticsPublished",
	PublishStart: "publish/start",
	PublishGetState: "publish/getState",
	PublishCancel: "publish/cancel",
	PublishSiteStart: "publish/startSite",
	PublishSiteGetState: "publish/siteState",
	PublishSiteCancel: "publish/siteCancel",
	EventPublishStarted: "event/publish.started",
	EventPublishProgress: "event/publish.progress",
	EventPublishCompleted: "event/publish.completed",
	EventPublishFailed: "event/publish.failed",
	EventPublishSiteProgress: "event/publish.siteProgress",
	EventPublishSiteCompleted: "event/publish.siteCompleted",
	EventPublishSiteFailed: "event/publish.siteFailed",
	HistorySnapshot: "history/snapshot",
	HistoryList: "history/list",
	HistoryGet: "history/get",
	HistoryDiff: "history/diff",
	HistoryRestore: "history/restore",
	HistoryDelete: "history/delete",
	HistoryTag: "history/tag",
	HistoryPrune: "history/prune",
	EventHistorySnapshotCreated: "event/history.snapshotCreated",
	EventHistoryRestored: "event/history.restored",
	EventHistoryDeleted: "event/history.deleted",
	EventHistoryMetaChanged: "event/history.metaChanged"
};
function isNotificationMethod(method) {
	return method.startsWith("event/");
}
const RequestMethods = Object.freeze(Object.values(Methods).filter((method) => !isNotificationMethod(method)));
const NotificationMethods = Object.freeze(Object.values(Methods).filter(isNotificationMethod));
//#endregion
export { isNotificationMethod as i, NotificationMethods as n, RequestMethods as r, Methods as t };
